export default "__VITE_ASSET__BAJnWxLv__"